var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgMinusSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 32H48C43.7565 32 39.6869 33.6857 36.6863 36.6863C33.6857 39.6869 32 43.7565 32 48V208C32 212.243 33.6857 216.313 36.6863 219.314C39.6869 222.314 43.7565 224 48 224H208C212.243 224 216.313 222.314 219.314 219.314C222.314 216.313 224 212.243 224 208V48C224 43.7565 222.314 39.6869 219.314 36.6863C216.313 33.6857 212.243 32 208 32ZM208 208H48V48H208V208ZM176 128C176 130.122 175.157 132.157 173.657 133.657C172.157 135.157 170.122 136 168 136H88C85.8783 136 83.8434 135.157 82.3431 133.657C80.8429 132.157 80 130.122 80 128C80 125.878 80.8429 123.843 82.3431 122.343C83.8434 120.843 85.8783 120 88 120H168C170.122 120 172.157 120.843 173.657 122.343C175.157 123.843 176 125.878 176 128Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusSquare);
export default __webpack_public_path__ + "static/media/minusSquare.3927d005a7a757d9a09847d2c9f8616c.svg";
export { ForwardRef as ReactComponent };